module.exports = __webpack_public_path__ + "static/thumb_shops-88082c6e811b716d8a89e8d49faa3fec.jpg";